
import Functions from "@/utils/functions.js";

export default {

  getToken() {
    return localStorage.getItem('token')
  },

  getRefToken() {
    return localStorage.getItem('ref_token')
  },

  getDataExpiredToken() {
    return localStorage.getItem('exp_data')
  },

  getAuthHeader() {
    return 'Bearer ' + this.getToken()
  },


  checkRemember() {
    return !!localStorage.getItem('ref_token')
  },

  checkAuth() {
    return !!localStorage.getItem('token')
  },


  getExpiration(tokenExpiration) {

    var now = new Date();
    now.setMinutes(now.getMinutes() + Math.ceil((tokenExpiration / 60)))

    return Functions.DateFormat(now);
  },


  clearStorage() {

    localStorage.clear();
  },


  logout() {

    // Puliza storage
    this.clearStorage()

    // Pulisce lo state perchè ricarica la pagina
    window.location = '/login'

  },

  setStorage(data) {

    localStorage.setItem('token', data.access_token);
    localStorage.setItem('exp_data', this.getExpiration(data.expires_in))

    if (data.refresh_token)
      localStorage.setItem('ref_token', data.refresh_token)
  },

  setCompCode(data) {
    localStorage.CompCode = data;
  },

  setCompName(data) {
    localStorage.CompName = data
  },





  getCompanyCode() {
    return localStorage.getItem('CompCode')
  },

  getCompanyName() {
    return localStorage.getItem('CompName')
  },

  clearCompanyData() {
    localStorage.removeItem('CompCode');
    localStorage.removeItem('CompName');
  }



}
